export default "__VITE_ASSET__90ba754b__"